import React, { useState, useEffect } from "react";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import COLORS from "../resources/colors/COLORS";
import SessionManager from "../Utils/SessionManager";
import { Redirect, useParams, useHistory } from "react-router-dom";
import "../css/Admin_css/admin-customize.css";
import myToast from "../Utils/MyToast";
import Iframe from "react-iframe";
import MdlSelectMultipleStudent from "../dialog/MdlSelectMultipleStudent";
import BackButton from "../ChildComponent/BackButton";

const PdAdmissionForm = () => {
  const { document_type } = useParams();
  const history = useHistory();

  const [loggedIn, setLoggedIn] = useState(!!localStorage.getItem("token"));
  const [Loading, setLoading] = useState(false);
  const [isOpenSelectStudent, setIsOpenSelectStudent] = useState(false);
  const [showStudentIdCard, setShowStudentIdCard] = useState(false);
  const [iframeLoading, setIframeLoading] = useState(false);
  const [mSelectedStudent, setMSelectedStudent] = useState([]);
  const [mPrintableSamples, setMPrintableSamples] = useState([]);
  const [mColorOption, setMColorOption] = useState([]);
  const [recentStudents, setRecentStudents] = useState([]);
  const [loadingRecentStudents, setLoadingRecentStudents] = useState(false);
  const [FILE_URL, setFILE_URL] = useState("");
  const [FILE_NAME, setFILE_NAME] = useState("");
  const [FILE_DIRECTORY, setFILE_DIRECTORY] = useState("");
  const [DOCUMENT_TYPE] = useState(document_type);
  const [SELECTED_SAMPLE_ID, setSELECTED_SAMPLE_ID] = useState("");
  const [SELECTED_SAMPLE_POSITION, setSELECTED_SAMPLE_POSITION] = useState(0);
  const [SELECTED_COLOR_POSITION, setSELECTED_COLOR_POSITION] = useState(0);
  const [COLOR_OPTION_ID, setCOLOR_OPTION_ID] = useState("");
    const [SELECTION_TYPE, setSELECTION_TYPE] = useState("");
    const [iFrameHeight, setIFrameHeight] = useState("800px");


  useEffect(() => {
    getPrintableSamples();
    getRecentAdmissions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Listen for iframe height messages
  useEffect(() => {
    const handleMessage = (event) => {
      // Check if message is from same origin or trusted source
      if (event.data && typeof event.data === 'object' && event.data.iframeHeight) {
        const height = parseInt(event.data.iframeHeight);
        if (height > 0) {
          setIFrameHeight(`${height}px`);
        }
      }
    };
    
    window.addEventListener("message", handleMessage, false);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  // Generate URL when all required data is available
  useEffect(() => {
    if (mSelectedStudent.length > 0 && FILE_NAME && FILE_DIRECTORY && SELECTED_SAMPLE_ID) {
      setFileUrL();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mSelectedStudent, FILE_NAME, FILE_DIRECTORY, SELECTED_SAMPLE_ID, COLOR_OPTION_ID, SELECTION_TYPE]);

  const getPrintableSamples = () => {
    setLoading(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getPrintableSample.php?";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    axios
      .get(URL, {
        params: {
          school_code: SCHOOL_CODE,
          document_type: DOCUMENT_TYPE,
        },
      })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        if (response.api_status === "OK") {
          setMPrintableSamples(response.data);
          setSample(SELECTED_SAMPLE_POSITION, response.data);
        } else {
          myToast.notify_warning(response.api_remark);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log("error>>>>>" + error);
      });
  };

  const setSample = (selected_sample_position, samples = mPrintableSamples) => {
    const sample = samples[selected_sample_position];
    setFILE_NAME(sample.file_name);
    setFILE_DIRECTORY(sample.file_directory);
    setSELECTED_SAMPLE_ID(sample.sample_id);
    getColorOptions(selected_sample_position, samples);
  };

  const getColorOptions = (
    selected_sample_position,
    samples = mPrintableSamples
  ) => {
    const colorOptions = samples[selected_sample_position].color_options || [];
    setMColorOption(colorOptions);
    setColorOptions(SELECTED_COLOR_POSITION, colorOptions);
  };

  const setColorOptions = (
    selected_position_color_option,
    colorOptions = mColorOption
  ) => {
    const selectedColor = colorOptions[selected_position_color_option];
    setCOLOR_OPTION_ID(selectedColor ? selectedColor.color_option_id : "");
  };

  const getRecentAdmissions = () => {
    setLoadingRecentStudents(true);
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getRecentAdmissions.php?";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    axios
      .get(URL, {
        params: {
          school_code: SCHOOL_CODE,
          limit: 20,
        },
      })
      .then((res) => res.data)
      .then((response) => {
        setLoadingRecentStudents(false);
        if (response.api_status === "OK") {
          setRecentStudents(response.data || []);
        } else {
          console.log("No recent admissions:", response.api_remark);
        }
      })
      .catch((error) => {
        setLoadingRecentStudents(false);
        console.log("error fetching recent admissions:", error);
      });
  };

  const handleAddRecentStudent = (student) => {
    const isAlreadySelected = mSelectedStudent.some(
      (s) => s.student_enrollment_no === student.student_enrollment_no
    );
    
    if (!isAlreadySelected) {
      // Add student
      const updatedStudents = [...mSelectedStudent, student];
      setMSelectedStudent(updatedStudents);
      setSELECTION_TYPE("student");
      // URL will be updated by useEffect
    } else {
      // Remove student
      const updatedStudents = mSelectedStudent.filter(
        (s) => s.student_enrollment_no !== student.student_enrollment_no
      );
      setMSelectedStudent(updatedStudents);
      if (updatedStudents.length === 0) {
        setSELECTION_TYPE("");
        setFILE_URL("");
        setIframeLoading(false);
      }
    }
  };

  const setFileUrL = () => {
    // Get current state values
    const currentFileName = FILE_NAME;
    const currentFileDirectory = FILE_DIRECTORY;
    const currentSampleId = SELECTED_SAMPLE_ID;
    const currentColorOptionId = COLOR_OPTION_ID;
    const currentSelectionType = SELECTION_TYPE;

    // Only generate URL if students are selected and required data is available
    if (mSelectedStudent.length === 0 || !currentFileName || !currentFileDirectory || !currentSampleId) {
      setFILE_URL("");
      setIframeLoading(false);
      console.log("setFileUrL: Missing required data", {
        students: mSelectedStudent.length,
        fileName: currentFileName,
        fileDirectory: currentFileDirectory,
        sampleId: currentSampleId
      });
      return;
    }

    const SCHOOL_CODE = SessionManager.getSchoolCode();
    let session_id = "";
    const mStudentIds = mSelectedStudent.map((student) => {
      session_id = student.session_id;
      return student.student_enrollment_no;
    });

    // Ensure we have valid student IDs
    if (mStudentIds.length === 0) {
      setFILE_URL("");
      setIframeLoading(false);
      console.log("setFileUrL: No student IDs");
      return;
    }

    const url =
      process.env.REACT_APP_SERVER_NAME +
      currentFileDirectory +
      currentFileName +
      "?&student_ids=" +
      JSON.stringify(mStudentIds) +
      "&class_id=" +
      "" +
      "&section_id=" +
      "" +
      "&session_id=" +
      session_id +
      "&sample_id=" +
      currentSampleId +
      "&selection_type=" +
      currentSelectionType +
      "&system_code=" +
      process.env.REACT_APP_SYSTEM_CODE +
      "&color_option_id=" +
      currentColorOptionId +
      "&school_code=" +
      SCHOOL_CODE;

    // Set loading state first, then update URL
    // This ensures the loader shows while the iframe loads
    setIframeLoading(true);
    // Use setTimeout to ensure loading state is set before URL change
    setTimeout(() => {
      setFILE_URL(url);
      console.log("FILE_URL generated:", url);
    }, 0);
  };

  const changeColor = (index) => {
    setSELECTED_COLOR_POSITION(index);
    setColorOptions(index, mColorOption);
  };

  const changeSample = (position) => {
    setSELECTED_SAMPLE_POSITION(position);
    setSample(position);
    // If students are already selected, reload the iframe
    if (mSelectedStudent.length > 0) {
      // setFileUrL will be called by setColorOptions after sample is set
    }
  };

  const SelectStudent = () => {
    setIsOpenSelectStudent(true);
  };

  const HandleCloseSelectStudent = () => {
    setIsOpenSelectStudent(false);
  };

  const HandleSelectedStudent = (selectedStudents) => {
    setIsOpenSelectStudent(false);
    const students = selectedStudents || [];
    setMSelectedStudent(students);
    
    if (students.length > 0) {
      setSELECTION_TYPE("student");
    } else {
      setFILE_URL("");
      setIframeLoading(false);
      setSELECTION_TYPE("");
    }
  };

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  // Add custom scrollbar styles
  const scrollbarStyles = `
    .custom-scrollbar::-webkit-scrollbar {
      height: 8px;
    }
    .custom-scrollbar::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 4px;
    }
    .custom-scrollbar::-webkit-scrollbar-thumb {
      background: ${COLORS.primary_color_shade3 || "#4FC3F7"};
      border-radius: 4px;
    }
    .custom-scrollbar::-webkit-scrollbar-thumb:hover {
      background: ${COLORS.primary_color_shade6 || "#0277BD"};
    }
  `;

  // Modern styles
  const modernStyles = {
    container: {
      maxWidth: "1600px",
      margin: "0 auto",
      padding: "24px",
      paddingTop: 0,
    },
    sectionCard: {
      background: "#fff",
      borderRadius: "8px",
      padding: "16px",
      marginBottom: "20px",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)",
      border: "1px solid #e5e7eb",
    },
    sectionTitle: {
      fontSize: "16px",
      fontWeight: "600",
      color: "#1f2937",
      marginBottom: "12px",
      display: "flex",
      alignItems: "center",
      gap: "8px",
    },
    selectButton: {
      padding: "12px 24px",
      borderRadius: "8px",
      background: `linear-gradient(135deg, ${COLORS.primary_color_shade6} 0%, ${COLORS.primary_color_shade8} 100%)`,
      color: "#fff",
      border: "none",
      cursor: "pointer",
      fontSize: "14px",
      fontWeight: "600",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      transition: "all 0.2s ease",
      boxShadow: `0 2px 4px ${COLORS.primary_color_shade3}`,
    },
    sampleContainer: {
      display: "flex",
      gap: "16px",
      overflowX: "auto",
      padding: "12px 0",
      scrollbarWidth: "thin",
      scrollbarColor: `${COLORS.primary_color_shade3} #f1f1f1`,
    },
    sampleCard: {
      minWidth: "140px",
      padding: "12px",
      borderRadius: "8px",
      border: "2px solid #e5e7eb",
      background: "#fff",
      cursor: "pointer",
      transition: "all 0.2s ease",
      textAlign: "center",
    },
    sampleCardSelected: {
      borderColor: COLORS.primary_color_shade6,
      background: COLORS.primary_color_shade1,
      boxShadow: `0 4px 12px ${COLORS.primary_color_shade3}40`,
    },
    sampleCardHover: {
      borderColor: COLORS.primary_color_shade6,
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
    sampleImage: {
      width: "100%",
      height: "110px",
      objectFit: "contain",
      borderRadius: "4px",
      marginBottom: "8px",
    },
    sampleName: {
      fontSize: "13px",
      fontWeight: "500",
      color: "#374151",
      marginTop: "8px",
    },
    colorContainer: {
      display: "flex",
      gap: "12px",
      flexWrap: "wrap",
      padding: "12px 0",
    },
    colorCard: {
      minWidth: "80px",
      padding: "8px",
      borderRadius: "8px",
      border: "2px solid #e5e7eb",
      background: "#fff",
      cursor: "pointer",
      transition: "all 0.2s ease",
    },
    colorCardSelected: {
      borderColor: COLORS.primary_color_shade6,
      background: COLORS.primary_color_shade1,
      boxShadow: `0 2px 8px ${COLORS.primary_color_shade3}40`,
    },
    colorCardHover: {
      borderColor: COLORS.primary_color_shade6,
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
    colorPreview: {
      display: "flex",
      height: "50px",
      borderRadius: "4px",
      overflow: "hidden",
      marginBottom: "6px",
    },
    colorHalf: {
      flex: 1,
    },
    colorName: {
      fontSize: "12px",
      fontWeight: "500",
      color: "#374151",
      textAlign: "center",
    },
    previewContainer: {
      borderRadius: "8px",
      border: "1px solid #e5e7eb",
      overflow: "hidden",
      background: "#fff",
      position: "relative",
      minHeight: "800px",
    },
    previewIframe: {
      width: "100%",
      border: "none",
    },
    loadingOverlay: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "rgba(255, 255, 255, 0.9)",
      zIndex: 10,
    },
  };

  return (
    <div className="content">
      <style>{scrollbarStyles}</style>
      <div className="content-header" style={{ background: COLORS.primary_color_shade5 }}>
        <div className="leftside-content-header">
          <ul className="breadcrumbs">
            <li>
              <i className="fa fa-home" aria-hidden="true" style={{ color: COLORS.white }} />
              <a href="#">Admission Form</a>
            </li>
          </ul>
        </div>
        <div className="rightside-content-header">
          <BackButton onClick={() => history.goBack()} />
        </div>
      </div>

      <div
        className="animated fadeInUp bg_page_white_rounded box_shadow"
        style={{ "--mMargin": "30px", padding: "0px" }}
      >
        {/* Header */}
        <div style={{ 
          width: "100%",
          background: `linear-gradient(135deg, ${COLORS.primary_color_shade6} 0%, ${COLORS.primary_color_shade8} 100%)`,
          padding: "16px 24px",
          borderRadius: "8px 8px 0 0",
          boxShadow: `0 2px 4px ${COLORS.primary_color_shade3}`,
          marginTop: 0
        }}>
          <h3 style={{ 
            fontSize: "24px", 
            fontWeight: "600", 
            color: "#fff",
            margin: 0,
            display: "flex",
            alignItems: "center",
            gap: "10px"
          }}>
            <i className="fa fa-file-text" aria-hidden="true" style={{ color: "#fff" }} />
            Admission Form
          </h3>
        </div>
        <div style={modernStyles.container}>

          {/* Select Students Button */}
          <div style={{ ...modernStyles.sectionCard, marginTop: "20px" }}>
              <button
                style={modernStyles.selectButton}
                onClick={SelectStudent}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-1px)";
                  e.currentTarget.style.boxShadow = `0 4px 8px ${COLORS.primary_color_shade3}`;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "";
                  e.currentTarget.style.boxShadow = `0 2px 4px ${COLORS.primary_color_shade3}`;
                }}
              >
                <i className="fa fa-users" aria-hidden="true" />
                Select Students
              </button>
            </div>

            {/* Recent Admissions */}
            {recentStudents.length > 0 && (
              <div style={modernStyles.sectionCard}>
                <div style={modernStyles.sectionTitle}>
                  <i className="fa fa-clock" aria-hidden="true" />
                  Recent Admissions
                </div>
                {loadingRecentStudents ? (
                  <div style={{ textAlign: "center", padding: "20px" }}>
                    <MyLoader />
                  </div>
                ) : (
                  <div style={{
                    display: "flex",
                    gap: "12px",
                    overflowX: "auto",
                    overflowY: "hidden",
                    padding: "12px 0",
                    scrollbarWidth: "thin",
                    scrollbarColor: `${COLORS.primary_color_shade3} #f1f1f1`,
                    WebkitOverflowScrolling: "touch",
                    msOverflowStyle: "-ms-autohiding-scrollbar",
                  }}
                  className="custom-scrollbar"
                  >
                    {recentStudents.map((student, index) => {
                      const isSelected = mSelectedStudent.some(
                        (s) => s.student_enrollment_no === student.student_enrollment_no
                      );
                      return (
                        <div
                          key={index}
                          onClick={() => handleAddRecentStudent(student)}
                          style={{
                            minWidth: "280px",
                            padding: "16px",
                            borderRadius: "12px",
                            border: isSelected 
                              ? `2px solid #10b981` 
                              : "2px solid #e5e7eb",
                            background: isSelected 
                              ? `linear-gradient(135deg, #d1fae5 0%, ${COLORS.white} 100%)`
                              : "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                            position: "relative",
                            overflow: "hidden",
                            boxShadow: isSelected 
                              ? `0 4px 12px rgba(16, 185, 129, 0.4)` 
                              : "0 2px 4px rgba(0, 0, 0, 0.05)",
                          }}
                          onMouseEnter={(e) => {
                            if (!isSelected) {
                              e.currentTarget.style.borderColor = "#10b981";
                              e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)";
                              e.currentTarget.style.transform = "translateY(-2px)";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (!isSelected) {
                              e.currentTarget.style.borderColor = "#e5e7eb";
                              e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
                              e.currentTarget.style.transform = "";
                            }
                          }}
                        >
                          {isSelected && (
                            <div style={{
                              position: "absolute",
                              top: "8px",
                              right: "8px",
                              width: "32px",
                              height: "32px",
                              borderRadius: "50%",
                              background: "#10b981",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              boxShadow: `0 2px 6px rgba(16, 185, 129, 0.4)`,
                              zIndex: 10,
                            }}>
                              <i className="fa fa-check" style={{ color: "#fff", fontSize: "16px", fontWeight: "bold" }} />
                            </div>
                          )}
                          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                            {/* First Row: Image and Student Info */}
                            <div style={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
                              {/* Student Image with Modern Frame */}
                              <div style={{
                                position: "relative",
                                width: "50px",
                                height: "50px",
                                flexShrink: 0,
                              }}>
                                <div style={{
                                  position: "absolute",
                                  inset: "-3px",
                                  borderRadius: "50%",
                                  background: `linear-gradient(135deg, ${COLORS.white} 0%, ${COLORS.primary_color_shade1} 100%)`,
                                  padding: "2px",
                                  boxShadow: `0 3px 8px ${COLORS.primary_color_shade3}60`,
                                }}>
                                  <div style={{
                                    width: "100%",
                                    height: "100%",
                                    borderRadius: "50%",
                                    background: "#fff",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    overflow: "hidden",
                                  }}>
                                    <img 
                                      src={student.student_img_path} 
                                      alt={student.stu_name}
                                      style={{ 
                                        width: "100%", 
                                        height: "100%", 
                                        objectFit: "cover",
                                        borderRadius: "50%",
                                      }}
                                      onError={(e) => {
                                        e.target.style.display = "none";
                                        if (e.target.nextSibling) {
                                          e.target.nextSibling.style.display = "flex";
                                        }
                                      }}
                                    />
                                    <div style={{
                                      display: "none",
                                      width: "100%",
                                      height: "100%",
                                      background: `linear-gradient(135deg, ${COLORS.primary_color_shade6} 0%, ${COLORS.primary_color_shade4} 100%)`,
                                      alignItems: "center",
                                      justifyContent: "center",
                                      color: "#fff",
                                      fontSize: "20px",
                                      fontWeight: "700",
                                    }}>
                                      {student.stu_name?.charAt(0)?.toUpperCase() || "S"}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              
                              {/* Student Name and Father Name */}
                              <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: "4px" }}>
                                <h5 style={{ 
                                  margin: 0, 
                                  fontSize: "15px", 
                                  fontWeight: "700", 
                                  color: COLORS.black8 || "#333333",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}>
                                  <i className="fa fa-user" style={{ fontSize: "13px", color: COLORS.primary_color_shade6 }} />
                                  {student.stu_name}
                                </h5>
                                {student.father_name && (
                                  <div style={{
                                    fontSize: "12px",
                                    color: "#6b7280",
                                    fontWeight: "500",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "4px",
                                  }}>
                                    <i className="fa fa-male" style={{ fontSize: "11px", color: COLORS.primary_color_shade6 }} />
                                    {student.father_name}
                                  </div>
                                )}
                                {student.registration_date && (
                                  <div style={{
                                    fontSize: "11px",
                                    color: "#9ca3af",
                                    fontWeight: "500",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "4px",
                                    marginTop: "2px",
                                  }}>
                                    <i className="fa fa-calendar" style={{ fontSize: "10px", color: "#6b7280" }} />
                                    {new Date(student.registration_date).toLocaleDateString('en-GB', { 
                                      day: '2-digit', 
                                      month: 'short', 
                                      year: 'numeric' 
                                    })}
                                  </div>
                                )}
                              </div>
                            </div>
                            
                            {/* Second Row: Badges */}
                            <div style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "8px",
                              alignItems: "center",
                            }}>
                              <div style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                                padding: "4px 10px",
                                background: COLORS.primary_color_shade1 || "#B3E5FC",
                                borderRadius: "6px",
                                border: `1px solid ${COLORS.primary_color_shade3 || "#4FC3F7"}`,
                                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)",
                              }}>
                                <i className="fa fa-hashtag" style={{ color: COLORS.primary_color_shade8 || "#0277BD", fontSize: "10px" }} />
                                <span style={{ fontSize: "12px", fontWeight: "600", color: COLORS.black8 || "#333333" }}>
                                  RollNo: {student.student_roll_no}
                                </span>
                              </div>
                              <div style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                                padding: "4px 10px",
                                background: COLORS.primary_color_shade1 || "#B3E5FC",
                                borderRadius: "6px",
                                border: `1px solid ${COLORS.primary_color_shade3 || "#4FC3F7"}`,
                                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)",
                              }}>
                                <i className="fa fa-graduation-cap" style={{ color: COLORS.primary_color_shade8 || "#0277BD", fontSize: "10px" }} />
                                <span style={{ fontSize: "12px", fontWeight: "600", color: COLORS.black8 || "#333333" }}>
                                  Class: {student.section_id === "No" ? student.class_name : `${student.class_name}:${student.section_name}`}
                                </span>
                              </div>
                              {student.sr_admission_no && (
                                <div style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                  padding: "4px 10px",
                                  background: COLORS.primary_color_shade1 || "#B3E5FC",
                                  borderRadius: "6px",
                                  border: `1px solid ${COLORS.primary_color_shade3 || "#4FC3F7"}`,
                                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)",
                                }}>
                                  <i className="fa fa-id-card" style={{ color: COLORS.primary_color_shade8 || "#0277BD", fontSize: "10px" }} />
                                  <span style={{ fontSize: "12px", fontWeight: "600", color: COLORS.black8 || "#333333" }}>
                                    SRN: {student.sr_admission_no}
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            )}

            {/* Sample List */}
            {Loading ? (
              <div style={modernStyles.sectionCard}>
                <div style={modernStyles.sectionTitle}>
                  <i className="fa fa-th-large" aria-hidden="true" />
                  Sample Templates
                </div>
                <div style={{ textAlign: "center", padding: "40px" }}>
                  <MyLoader />
                </div>
              </div>
            ) : (
              mPrintableSamples.length > 1 && (
                <div style={modernStyles.sectionCard}>
                  <div style={modernStyles.sectionTitle}>
                    <i className="fa fa-th-large" aria-hidden="true" />
                    Sample Templates
                  </div>
                  <div style={modernStyles.sampleContainer}>
                    {mPrintableSamples.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        ...modernStyles.sampleCard,
                        ...(SELECTED_SAMPLE_POSITION === index
                          ? modernStyles.sampleCardSelected
                          : {}),
                      }}
                      onClick={() => changeSample(index)}
                      onMouseEnter={(e) => {
                        if (SELECTED_SAMPLE_POSITION !== index) {
                          Object.assign(e.currentTarget.style, modernStyles.sampleCardHover);
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (SELECTED_SAMPLE_POSITION !== index) {
                          e.currentTarget.style.borderColor = "#e5e7eb";
                          e.currentTarget.style.background = "#fff";
                          e.currentTarget.style.boxShadow = "";
                        }
                      }}
                    >
                      <img
                        src={item.sample_img}
                        alt={item.sample_name}
                        style={modernStyles.sampleImage}
                      />
                      <div style={modernStyles.sampleName}>{item.sample_name}</div>
                    </div>
                  ))}
                  </div>
                </div>
              )
            )}

            {/* Color Options */}
            {mColorOption.length > 0 && (
              <div style={modernStyles.sectionCard}>
                <div style={modernStyles.sectionTitle}>
                  <i className="fa fa-paint-brush" aria-hidden="true" />
                  Color Options
                </div>
                <div style={modernStyles.colorContainer}>
                  {mColorOption.map((item, index) => {
                    const [color1, color2] = item.sample_color_code.split("_");
                    return (
                      <div
                        key={index}
                        style={{
                          ...modernStyles.colorCard,
                          ...(SELECTED_COLOR_POSITION === index
                            ? modernStyles.colorCardSelected
                            : {}),
                        }}
                        onClick={() => changeColor(index)}
                        onMouseEnter={(e) => {
                          if (SELECTED_COLOR_POSITION !== index) {
                            Object.assign(e.currentTarget.style, modernStyles.colorCardHover);
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (SELECTED_COLOR_POSITION !== index) {
                            e.currentTarget.style.borderColor = "#e5e7eb";
                            e.currentTarget.style.background = "#fff";
                            e.currentTarget.style.boxShadow = "";
                          }
                        }}
                      >
                        <div style={modernStyles.colorPreview}>
                          <div
                            style={{
                              ...modernStyles.colorHalf,
                              backgroundColor: color1,
                            }}
                          />
                          <div
                            style={{
                              ...modernStyles.colorHalf,
                              backgroundColor: color2,
                            }}
                          />
                        </div>
                        <div style={modernStyles.colorName}>{item.sample_color_name}</div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {/* Preview */}
            <div style={modernStyles.sectionCard}>
              <div style={modernStyles.sectionTitle}>
                <i className="fa fa-eye" aria-hidden="true" />
                Preview
              </div>
              <div style={modernStyles.previewContainer}>
                {iframeLoading && (
                  <div style={modernStyles.loadingOverlay}>
                    <div style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "12px",
                    }}>
                      <i 
                        className="fa fa-spinner fa-spin" 
                        style={{ 
                          fontSize: "32px", 
                          color: COLORS.primary_color_shade6 || "#0277BD" 
                        }} 
                      />
                      <div style={{
                        fontSize: "14px",
                        color: "#6b7280",
                        fontWeight: "500",
                      }}>
                        Loading preview...
                      </div>
                    </div>
                  </div>
                )}
                {FILE_URL && (
                  <Iframe
                    url={FILE_URL}
                    width="100%"
                    height={iFrameHeight}
                    scrolling="no"
                    id="iFrameStudentId"
                    display="initial"
                    position="relative"
                    onLoad={() => {
                      setIframeLoading(false);
                      setShowStudentIdCard(false);
                      // Try to get iframe content height after load
                      try {
                        const iframe = document.getElementById('iFrameStudentId');
                        if (iframe && iframe.contentWindow) {
                          // Request height from iframe
                          iframe.contentWindow.postMessage({ type: 'getHeight' }, '*');
                        }
                      } catch (e) {
                        console.log('Cannot access iframe:', e);
                      }
                    }}
                    onError={() => {
                      setIframeLoading(false);
                      setShowStudentIdCard(false);
                    }}
                    styles={{
                      ...modernStyles.previewIframe,
                      height: iFrameHeight,
                      minHeight: "800px",
                    }}
                  />
                )}
                {!FILE_URL && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "800px",
                      color: "#9ca3af",
                      fontSize: "14px",
                    }}
                  >
                    <div style={{ textAlign: "center" }}>
                      <i className="fa fa-file-pdf-o" style={{ fontSize: "48px", marginBottom: "12px" }} />
                      <div>Please select students to preview the document</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
        </div>
      </div>

      {isOpenSelectStudent && (
        <MdlSelectMultipleStudent
          actionClose={HandleCloseSelectStudent}
          actionHandleSelected={HandleSelectedStudent}
        />
      )}
    </div>
  );
};

export default PdAdmissionForm;

